/*
 * Action Types
 */
export enum WalletHistoryTypes {
  GET_HISTORY_REQUEST = '@wallet/GET_HISTORY_REQUEST',
  GET_HISTORY_SUCCESS = '@wallet/GET_HISTORY_SUCCESS',
  GET_HISTORY_FAILURE = '@wallet/GET_HISTORY_FAILURE',
}

/*
 * Data types
 */
export interface WalletHistoryInterface {
  id: string;
  date: string;
  place: string;
  document: string;
  amount: number;
  operation: number;
}

/*
 * State type
 */
export interface WalletHistoryState {
  readonly walletHistoryList: WalletHistoryInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
